import api from 'api/api'
import { toast } from "react-toastify"

import { API_URL } from 'constants/index'

export const GET_USER_SERVICES_BY_DATE = '[USERS_SERVICES] GET USER SERVICES BY DATE'
export const GET_EXISTING_USER_SERVICES_BY_MONTH_AND_YEAR = '[USERS_SERVICES] GET EXISTING USER SERVICES BY MONTH AND YEAR'
export const GET_USER_SERVICES_BY_STATUS = '[USERS_SERVICES] GET USER SERVICES BY STATUS'
export const SAVE_USER_SERVICE = '[USERS_SERVICES] SAVE USER SERVICE'
export const RESCHEDULE_USER_SERVICE = '[USERS_SERVICES] RESCHEDULE USER SERVICE'
export const CANCEL_USER_SERVICE = '[USERS_SERVICES] CANCEL USER SERVICE'
export const REMOVE_USER_SERVICE = '[USERS_SERVICES] DELETE USER SERVICE'
export const EXECUTE_USER_SERVICE = '[USERS_SERVICES] EXECUTE USER SERVICE'
export const DONE_USER_SERVICE = '[USERS_SERVICES] DONE USER SERVICE'
export const REVERT_USER_SERVICE = '[USERS_SERVICES] REVERT USER SERVICE'
export const GET_CUSTOMERS_FROM_USER_SERVICES = '[USERS_SERVICES] GET CUSTOMERS FROM USER SERVICES'

export function getUserServicesByDate(date) {
  const request = api.get(`/user-service/services-by-date/${date}`)
  return (dispatch) => {
    dispatch({ type: GET_USER_SERVICES_BY_DATE, payload: { loading: true } })
    request.then((response) => {

      dispatch({ type: GET_USER_SERVICES_BY_DATE, payload: { loading: false, data: response.data.data } })
    }).catch((error) => {
      dispatch({ type: GET_USER_SERVICES_BY_DATE, payload: { loading: false } })
      toast.error("Error inesperado, no se pudo obtener los servicios")
      console.log(GET_USER_SERVICES_BY_DATE, error)
    })
  }
}

export function getExistingUserServicesByMonthAndYear(month, year) {
  const request = api.get(`/user-service/existing-services-by-month-and-year/${month}/${year}`)
  return (dispatch) => {
    dispatch({ type: GET_EXISTING_USER_SERVICES_BY_MONTH_AND_YEAR, payload: { loading: true } })
    request.then((response) => {

      dispatch({ type: GET_EXISTING_USER_SERVICES_BY_MONTH_AND_YEAR, payload: { loading: false, data: response.data.data } })
    }).catch((error) => {
      dispatch({ type: GET_EXISTING_USER_SERVICES_BY_MONTH_AND_YEAR, payload: { loading: false } })
      toast.error("Error inesperado, no se pudo obtener los servicios")
      console.log(GET_EXISTING_USER_SERVICES_BY_MONTH_AND_YEAR, error)
    })
  }
}

export function getUserServicesByStatus(status) {
  const request = api.get(`/user-service/services-by-status/${status}`)
  return (dispatch) => {
    dispatch({ type: GET_USER_SERVICES_BY_STATUS, payload: { loading: true } })
    request.then((response) => {

      dispatch({ type: GET_USER_SERVICES_BY_STATUS, payload: { loading: false, data: response.data.data } })
    }).catch((error) => {
      dispatch({ type: GET_USER_SERVICES_BY_STATUS, payload: { loading: false } })
      toast.error("Error inesperado, no se pudo obtener los servicios")
      console.log(GET_USER_SERVICES_BY_STATUS, error)
    })
  }
}

export function rescheduleUserService(data) {
  const request = api.post(`/user-service/reschedule`, data)
  return (dispatch) => {
    dispatch({ type: RESCHEDULE_USER_SERVICE, payload: { rescheduling_id: data.servicio_usuario_id } })
    request.then((response) => {

      if (Number(response.data.status) !== 200) {
        dispatch({ type: RESCHEDULE_USER_SERVICE, payload: { rescheduling_id: data.servicio_usuario_id } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: RESCHEDULE_USER_SERVICE, payload: { rescheduled_id: data.servicio_usuario_id } })
      dispatch({
        type: RESCHEDULE_USER_SERVICE, payload: {
          rescheduled_id: data.servicio_usuario_id,
          rescheduling_id: data.servicio_usuario_id,
          data: response.data.data
        }
      })
      toast.success(response.data.message)
    }).catch((error) => {
      dispatch({ type: RESCHEDULE_USER_SERVICE, payload: { rescheduling_id: data.servicio_usuario_id } })
      toast.error("Error inesperado, no se pudo reprogramar el servicio")
      console.log(RESCHEDULE_USER_SERVICE, error)
    })
  }
}

export function cancelUserService(data) {
  const request = api.post(`/user-service/cancel`, data)
  return (dispatch) => {
    dispatch({ type: CANCEL_USER_SERVICE, payload: { canceling_id: data.servicio_usuario_id } })
    request.then((response) => {

      if (Number(response.data.status) !== 200) {
        dispatch({ type: CANCEL_USER_SERVICE, payload: { canceling_id: data.servicio_usuario_id } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: CANCEL_USER_SERVICE, payload: { canceled_id: data.servicio_usuario_id } })
      dispatch({
        type: CANCEL_USER_SERVICE, payload: {
          canceled_id: data.servicio_usuario_id,
          canceling_id: data.servicio_usuario_id,
          data: response.data.data
        }
      })
      toast.success(response.data.message)
    }).catch((error) => {
      dispatch({ type: CANCEL_USER_SERVICE, payload: { canceling_id: data.servicio_usuario_id } })
      toast.error("Error inesperado, no se pudo cancelar el servicio")
      console.log(CANCEL_USER_SERVICE, error)
    })
  }
}

export function saveUserService(data) {
  const request = api.post(`/user-service/save`, data)
  return (dispatch) => {
    dispatch({ type: SAVE_USER_SERVICE, payload: { saving_id: data.servicio_usuario_id } })
    request.then((response) => {

      if (Number(response.data.status) !== 200) {
        dispatch({ type: SAVE_USER_SERVICE, payload: { saving_id: data.servicio_usuario_id } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: SAVE_USER_SERVICE, payload: { saved_id: data.servicio_usuario_id } })
      dispatch({
        type: SAVE_USER_SERVICE, payload: {
          saved_id: data.servicio_usuario_id,
          saving_id: data.servicio_usuario_id,
          data: response.data.data
        }
      })
      toast.success(response.data.message)
    }).catch((error) => {
      dispatch({ type: SAVE_USER_SERVICE, payload: { saving_id: data.servicio_usuario_id } })
      toast.error("Error inesperado, no se pudo guardar el servicio")
      console.log(SAVE_USER_SERVICE, error)
    })
  }
}

export function removeUserService(userServiceId) {
  const request = api.delete(`/user-service/remove/${userServiceId}`)
  return (dispatch) => {
    dispatch({ type: REMOVE_USER_SERVICE, payload: { removing_id: userServiceId } })
    request.then((response) => {

      if (Number(response.data.status) !== 200) {
        dispatch({ type: REMOVE_USER_SERVICE, payload: { removing_id: userServiceId } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: REMOVE_USER_SERVICE, payload: { removed_id: userServiceId } })
      dispatch({
        type: REMOVE_USER_SERVICE, payload: {
          removed_id: userServiceId,
          removing_id: userServiceId
        }
      })
      toast.success(response.data.message)
    }).catch((error) => {
      dispatch({ type: REMOVE_USER_SERVICE, payload: { removing_id: userServiceId } })
      toast.error("Error inesperado, no se pudo remover el servicio")
      console.log(REMOVE_USER_SERVICE, error)
    })
  }
}

export function executeUserService(data) {
  const request = api.post(`/user-service/execute`, data)
  return (dispatch) => {
    dispatch({ type: EXECUTE_USER_SERVICE, payload: { executing_id: data.servicio_usuario_id } })
    request.then((response) => {

      if (Number(response.data.status) !== 200) {
        dispatch({ type: EXECUTE_USER_SERVICE, payload: { executing_id: data.servicio_usuario_id } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: EXECUTE_USER_SERVICE, payload: { executed_id: data.servicio_usuario_id } })
      dispatch({
        type: EXECUTE_USER_SERVICE, payload: {
          executed_id: data.servicio_usuario_id,
          executing_id: data.servicio_usuario_id,
          data: response.data.data
        }
      })
      toast.success(response.data.message)
    }).catch((error) => {
      dispatch({ type: EXECUTE_USER_SERVICE, payload: { executing_id: data.servicio_usuario_id } })
      toast.error("Error inesperado, no se pudo iniciar el servicio")
      console.log(EXECUTE_USER_SERVICE, error)
    })
  }
}

export function doneUserService(data) {
  const request = api.post(`/user-service/done`, data)
  return (dispatch) => {
    dispatch({ type: DONE_USER_SERVICE, payload: { loading_id: data.servicio_usuario_id } })
    request.then((response) => {

      if (Number(response.data.status) !== 200) {
        dispatch({ type: DONE_USER_SERVICE, payload: { loading_id: data.servicio_usuario_id } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: DONE_USER_SERVICE, payload: { done_id: data.servicio_usuario_id } })
      dispatch({
        type: DONE_USER_SERVICE, payload: {
          done_id: data.servicio_usuario_id,
          loading_id: data.servicio_usuario_id,
          data: response.data.data
        }
      })
      toast.success(response.data.message)
    }).catch((error) => {
      dispatch({ type: DONE_USER_SERVICE, payload: { loading_id: data.servicio_usuario_id } })
      toast.error("Error inesperado, no se pudo finalizar el servicio")
      console.log(DONE_USER_SERVICE, error)
    })
  }
}

export function revertUserService(userServiceId) {
  const request = api.post(`/user-service/revert/${userServiceId}`)
  return (dispatch) => {
    dispatch({ type: REVERT_USER_SERVICE, payload: { reverting_id: userServiceId } })
    request.then((response) => {

      if (Number(response.data.status) !== 200) {
        toast.error(response.data.message)
        return
      }
      dispatch({ type: REVERT_USER_SERVICE, payload: { reverted_id: userServiceId } })
      toast.success(response.data.message, { autoClose: 5500 })
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo revertir el servicio")
      console.log(REVERT_USER_SERVICE, error)
    }).finally(() => {
      dispatch({ type: REVERT_USER_SERVICE, payload: { reverting_id: userServiceId, reverted_id: userServiceId } })
    })
  }
}

export function getCustomersFromUserServices() {
  const request = api.get(`/user-service/customers`)
  return (dispatch) => {
    dispatch({ type: GET_CUSTOMERS_FROM_USER_SERVICES, payload: { loading: true } })
    request.then((response) => {

      dispatch({ type: GET_CUSTOMERS_FROM_USER_SERVICES, payload: { loading: false, data: response.data.data } })
    }).catch((error) => {
      dispatch({ type: GET_CUSTOMERS_FROM_USER_SERVICES, payload: { loading: false } })
      toast.error("Error inesperado, no se pudo obtener los clientes")
      console.log(GET_CUSTOMERS_FROM_USER_SERVICES, error)
    })
  }
}

